import { render, staticRenderFns } from "./ListTeams.vue?vue&type=template&id=b90b0632&"
import script from "./ListTeams.vue?vue&type=script&lang=js&"
export * from "./ListTeams.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ListTeams.vue?vue&type=style&index=1&id=b90b0632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports